import { io } from 'socket.io-client';

const socket = io("https://api.springwayhub.com", {
  transports: ["websocket"]
});

export default socket;